const videoCarousel = () => {
    const classes = {
        videoCarouselToggleActive: 'video-carousel__video--active',
        videoCarouselModalVisible: 'video-carousel__modal--visible',
    };
    const selectors = {
        videoCarouselSection: '[data-video-carousel]',
        videoCarouselSectionAutoplayDurationAttr: 'data-video-carousel-autoplay-duration',
        videoCarouselToggle: '[data-video-carousel-toggle]',
        videoCarouselToggleAttr: 'data-video-carousel-toggle',
        videoCarouselToggleVideo: 'video',
        videoCarouselModal: '[data-video-carousel-modal]',
        videoCarouselModalActiveItem: 'data-video-carousel-modal-active-item',
        videoCarouselModalVideo: '[data-video-carousel-modal-video]',
        videoCarouselModalClose: '[data-video-carousel-modal-close]',
    };
    const videoCarouselSections = document.querySelectorAll(selectors.videoCarouselSection);
    videoCarouselSections.forEach((section) => {
        const modal = section.querySelector(selectors.videoCarouselModal);
        const modalVideoContainer = modal.querySelector(selectors.videoCarouselModalVideo);
        const modalClose = section.querySelector(selectors.videoCarouselModalClose);
        const toggles = section.querySelectorAll(selectors.videoCarouselToggle);
        toggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                const video = toggle.querySelector(selectors.videoCarouselToggleVideo);
                if (video) {
                    const ID = toggle.getAttribute(selectors.videoCarouselToggleAttr);
                    const source = video.querySelector('source');
                    const src = source ? source.getAttribute('src') : video.getAttribute('src');
                    const videoClone = document.createElement('video');
                    videoClone.setAttribute('autoplay', '');
                    videoClone.setAttribute('controls', '');
                    videoClone.setAttribute('playsinline', '');
                    const newSource = document.createElement('source');
                    newSource.setAttribute('src', src);
                    videoClone.appendChild(newSource);
                    modalVideoContainer.innerHTML = '';
                    modalVideoContainer.appendChild(videoClone);
                    modal.classList.add(classes.videoCarouselModalVisible);
                    modal.setAttribute(selectors.videoCarouselModalActiveItem, ID);
                }
            });
        });
        modalClose.addEventListener('click', () => {
            const modalVideo = modal.querySelector(selectors.videoCarouselToggleVideo);
            if (modalVideo) {
                modalVideo.pause();
            }
            modal.classList.remove(classes.videoCarouselModalVisible);
        });
        // Play Short Video Snippet?
        const autoplayDuration = section.getAttribute(selectors.videoCarouselSectionAutoplayDurationAttr);
        if (autoplayDuration) {
            let currentIndex = 0;
            const intervalTime = parseInt(autoplayDuration);
            const loopVideos = () => {
                toggles.forEach((toggle) => {
                    toggle.classList.remove(classes.videoCarouselToggleActive);
                    toggle.querySelector(selectors.videoCarouselToggleVideo).pause();
                });
                toggles[currentIndex].classList.add(classes.videoCarouselToggleActive);
                toggles[currentIndex].querySelector(selectors.videoCarouselToggleVideo).play();
                // Scroll
                const toggleContainer = section.querySelector('.scroll-area');
                const offsetLeft = toggles[currentIndex].offsetLeft;
                const tabWidth = toggles[currentIndex].offsetWidth;
                const containerWidth = toggleContainer.offsetWidth;
                let extraSpace = containerWidth - tabWidth;
                extraSpace = extraSpace / 2;
                toggleContainer.scrollLeft = offsetLeft - extraSpace;
                // Back to the start
                currentIndex = (currentIndex + 1) % toggles.length;
            };
            setInterval(loopVideos, intervalTime);
        }
    });
};
export { videoCarousel };
